var setContainerSizeTries = 0; //this runs sometimes before image loads so try a few times before giving up
                               //could put a mutation observer on the parent object if dont like the tries

//This updates the footer text with text from footer-seo-text.js.liquid
  updateSEO = function() {
    try {
      var html = getFooterSEO();

      if (html.length > 0)
      {
        $('.footerseo').remove();
        $('.site-footer.footerBg').before(html);
      }
    }
    catch(err) {
      console.log('Footer SEO error');
      console.log(err);
    }
  }
//Set height of irregular promo block on homepage
function setContainerSize() {
  var left_img_height = $('.left-img-2').height();

  if (left_img_height == 0 && setContainerSizeTries++ < 10)  //try 10 times then give up
  {
    setTimeout(function(){setContainerSize();},200);
    return;
  }

  var long_block_height = left_img_height * 2;
  //var long_block = $('.long_block').height(long_block_height + 7);

  //$('img.img-bg.img_desk, img.img-bg.img_hover').height(long_block_height + 10);
}

// Toggling popup on PDP
function popup() {

  //mobile social sharing
  if ($(window).width() < 768){
    $('.template-product .m-product-social').on('click', function(e){
      $('.template-product .m_social_bg').addClass('clicked');
    });

    $('.template-product .m_social_bg').on('click', function(e) {
      if($(e.target).hasClass('m_social_cell')) {
        $(this).closest('.template-product .m_social_bg').removeClass('clicked');
      };
    })

    $('.template-product .s_close').on('click', function(){
      $(this).closest('.template-product .m_social_bg').removeClass('clicked');
    });
  }

  //assistance contact form
  $('.template-product .needAssistance').on('click', function(){
    $('.template-product .assist_bg').addClass('clicked');
  });

  $('.setAppointment').on('click', function(){
    localStorage.setItem('appointmentProduct', $('span.variant-sku').text() + ' ' + $('.product-single__meta h1').text());
    window.location = '/apps/book-an-appointment/appointments/new';
  });

  $('.template-product .s_close').on('click', function(){
    $(this).closest('.template-product .assist_bg').removeClass('clicked');
  });
  $('.assist_share').click(function(e){e.stopPropagation();})
  $('.template-product .assist_bg').click(function(){$(this).removeClass('clicked');})
}



function cartValueChanged() {
  if($('#gift-trigger').is(":checked"))
    $("#checkout-addnote").show();
  else
    $("#checkout-addnote").hide();
}




function bgFill(){
    var peopleImage1 = $('.people.girl-white').attr('src');
    $('.white-block').css({'background-image': 'url(' + peopleImage1 + ')'});

    var peopleImage2 = $('.people.girl-black').attr('src');
    $('.black-block').css({'background-image': 'url(' + peopleImage2 + ')'});
}

var tries = 0;
var prodToSee = '';

function tryApptPage(){
    if (window.location.href.indexOf('appointments') == -1)
      return;

    setApptDetails();
}

function setApptDetails(){
    if (($('#customFieldWhatareyouinterestedin').length == 0  || typeof angular.element(document.getElementById('customFieldWhatareyouinterestedin')).scope().appointmentRequest.customer.customFields === 'undefined')&& tries++ < 20)
    {
      console.log(tries);
      setTimeout(function(){setApptDetails();},250);
      return;
    }

    prodToSee = localStorage.getItem('appointmentProduct');
      localStorage.removeItem('appointmentProduct');

    if (prodToSee && prodToSee.length > 0 && $('#customFieldWhatareyouinterestedin').attr('value') != prodToSee)
    {
      //$('#customFieldProduct').unbind();
      //this is terrible, expects the first custom field to be the product, will be ok as long as not modded
	  angular.element(document.getElementById('customFieldWhatareyouinterestedin')).scope().appointmentRequest.customer.customFields[0].value = prodToSee;
      $('#customFieldWhatareyouinterestedin').after('<span>'+prodToSee+'</span>');
      $('#customFieldWhatareyouinterestedin').hide();
    }
}


$(document).ready( function () {
  updateSEO();
  tryApptPage();
  if($('body').hasClass('template-index')){
    if ($(window).width() > 768){
      setContainerSize();
    }
  }

  $('.new-store h2').click(function(e){
    $(this).next('.stores-list').slideToggle();
  });

  //Setting the banner image for pages using background-image
  var bgImage = $('.contact-header img').attr('src');
  $('.contact-header').css({'background-image': 'url(' + bgImage + ')'});



  /**************/
  /* WHO WE ARE */
  /**************/

  if($('body').hasClass('WhoWeAre')){
    bgFill();

    $(window).resize(function() {
      if ($(window).width() > 768  ){
        bgFill();
      }
    })
  }



  /**********/
  /* SEARCH */
  /**********/

  if($('body').hasClass('template-search')){
    if($('.error-msg').is(':visible')){
      $('.template-search .collection-main, .template-search .filter-popup').addClass('hide');
    }

    //Open filter popup
    $('.page-width .filter-popup').click(function(){
      $('.filters-toolbar-wrapper, .bg-overlay').toggle();
    });
  }



  /**********/
  /* HEADER */
  /**********/

  if($(window).width() <= 1023 ){
    setTimeout(function(){
      $('.globomenu .globomenu-target').on('click', function(event){
        $('li.globomenu-item.globomenu-has-submenu-drop').removeClass('globomenu-active');
        $(this).closest('li.globomenu-item.globomenu-has-submenu-drop').addClass('globomenu-active');
      });

      $(".globomenu .globomenu-item.globomenu-item-level-0.globomenu-has-submenu-mega:nth-of-type(1) .globomenu-submenu-type-stack").append('<li class="globomenu-item  globomenu-item-normal"><a class="globomenu-target" href="/pages/shop-our-instagram"><span class="globomenu-target-title globomenu-target-text">Shop Instagram</span></a></li>');
      $(".globomenu .globomenu-item.globomenu-item-level-0.globomenu-has-submenu-mega:nth-of-type(1) .globomenu-submenu-type-stack").append('<li class="globomenu-item  globomenu-item-normal"><a class="globomenu-target" href="/collections/new-arrivals"><span class="globomenu-target-title globomenu-target-text">New Arrivals</span></a></li>');

      $(".globomenu .globomenu-item.globomenu-item-level-0.globomenu-has-submenu-mega:nth-of-type(2) .globomenu-submenu-type-stack").append('<li class="globomenu-item  globomenu-item-normal"><a class="globomenu-target" href="/collections/engagement-rings"><span class="globomenu-target-title globomenu-target-text">Engagement Rings</span></a></li>');
      $(".globomenu .globomenu-item.globomenu-item-level-0.globomenu-has-submenu-mega:nth-of-type(2) .globomenu-submenu-type-stack").append('<li class="globomenu-item  globomenu-item-normal"><a class="globomenu-target" href="/collections/wedding-bands"><span class="globomenu-target-title globomenu-target-text">Wedding Bands</span></a></li>');

      $(".globomenu .globomenu-item.globomenu-item-level-0.globomenu-has-submenu-mega:nth-of-type(6) .globomenu-submenu-type-stack").append('<li class="globomenu-item  globomenu-item-normal"><a class="globomenu-target" href="/collections/engagement-rings"><span class="globomenu-target-title globomenu-target-text">Discover Our Blog</span></a></li>');
      $(".globomenu .globomenu-item.globomenu-item-level-0.globomenu-has-submenu-mega:nth-of-type(6) .globomenu-submenu-type-stack").append('<li class="globomenu-item  globomenu-item-normal"><a class="globomenu-target" href="/collections/wedding-bands"><span class="globomenu-target-title globomenu-target-text">Shop Heirloom</span></a></li>');
    } , 500);
  }

  setTimeout(function(){
    $('.globomenu .globomenu-target').on('click', function(event){
      $('li.globomenu-item.globomenu-has-submenu-drop').removeClass('globomenu-active');
      $(this).closest('li.globomenu-item.globomenu-has-submenu-drop').addClass('globomenu-active');
    });
  } , 500);



  /*******/
  /* PLP */
  /*******/
  if($('body').hasClass('template-collection')){

    // Scroll to top - From Fashionopolism
    $(window).scroll(function(){
      if ($(this).scrollTop() > 100) {
        $('.template-collection .scrollup').fadeIn();
      } else {
        $('.template-collection .scrollup').fadeOut();
      }
    });

    $('.scrollup').click(function(){
      $("html, body").animate({ scrollTop: 0 }, 800);
      return false;
    });


    //Open filter popup
    $('.page-width .filter-popup').click(function(){
      $('.filters-toolbar-wrapper, .bg-overlay').toggle();
    });

    $(document).mouseup(function(e) {
      var $signUp = $(".filters-toolbar-wrapper");
      if(!$signUp.is(e.target) && $signUp.has(e.target).length === 0)
      {
        $('.filters-toolbar-wrapper, .bg-overlay').hide();
      }
    });
  }


  /********/
  /* PDP  */
  /********/
  if($('body').hasClass('template-product')){

    //Add hover-popup-container after swym-button-bar
    setTimeout(function(){
      $('.template-product .swym-button-bar').append('<span class="hover-popover-container">Add to Wishlist</span>')}
               , 5000);

    //Toggling social and contact popup
    popup();

    //Hide selector for Color
    $('.template-product .selector-wrapper').each(function(i,o){
      if($(o).find('label').text().trim().toLowerCase() === 'color:'){
        // && $(o).find('option').length == 1) {
        $(this).hide();
      }
    })

  }



  /******************/
  /* ACCOUNT PAGES  */
  /******************/
  if($('body').hasClass('customers-addresses')){
    $('.customers-addresses .page-width.text-center').on('click', function(){
      $('.customers-addresses .page-width').addClass('add');
      $('.customers-addresses .main-content').addClass('add');
      $('.customers-addresses .page-width.text-center.add .address-new-toggle').hide();
    });

    $('.customers-addresses .address_form .address-new-toggle').on('click', function(){
      $('.customers-addresses .page-width').removeClass('add');
      $('.customers-addresses .main-content').removeClass('add');
      $('.customers-addresses .page-width.text-center.add .address-new-toggle').show();
    });
  }


  /*********************/
  /* BLOG and ARTICLE  */
  /*********************/

  if($('body').hasClass('template-blog')){
    var pathArray = window.location.pathname.split( '/' );
    var tag = pathArray[4];

    $('.category-container .mag_name').each(function(){
      var list = $(this).text();
      console.log(list);

      if( tag == 'doyle-doyle-brides') {
        if($(this).text() == 'Doyle & Doyle Brides'){
          $(this).addClass('current-tag')
        }
      } else if ( tag == 'birthstone-jewels') {
        if($(this).text() == 'Birthstones'){
          $(this).addClass('current-tag')
        }
      } else if ( tag == 'gift-ideas'){
        if($(this).text() == 'Gift ideas'){
          $(this).addClass('current-tag')
        }
      } else if ( tag == 'history'){
        if($(this).text() == 'Jewelry History'){
          $(this).addClass('current-tag')
        }
      } else if ( tag == 'museum-exhibition'){
        if($(this).text() == 'Museum Exhibition'){
          $(this).addClass('current-tag')
        }
      } else {

      }
    });
  }

});



/*********************/
/* ON WINDOW RESIZE  */
/*********************/

$( window ).resize(function() {

  if($('body').hasClass('template-index')){
    //Setting height of blocks on homepage
    if ($(window).width() > 768){ setContainerSize();}
  }

});

var swatches = {
  metals: {
    "Platinum": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Metal/Platinum.png",
    "Rose Gold": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Metal/Rose-Gold.png",
    "Silver": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Metal/Silver.png",
    "White Gold": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Metal/White-Gold.png",
    "Yellow Gold": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Metal/Yellow-Gold.png"
  },
  gemstones: {
    "All other stones": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/All-other-stones.png",
    "Amethyst": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Amethyst.png",
    "Aquamarine": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Aquamarine.png",
    "Citrine": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Citrine.png",
    "Coral": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Coral.png",
    "Diamond": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Diamond.png",
    "Emerald": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Emerald.png",
    "Garnet": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Garnet.png",
    "Hematite": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Hematite.png",
    "Lapis": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Lapis.png",
    "Moonstone": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Moonstone.png",
    "Onyx": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Onyx.png",
    "Opal": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Opal.png",
    "Pearl": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Pearl.png",
    "Peridot": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Peridot.png",
    "Rock Crystal": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Rock-Crystal.png",
    "Ruby": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Ruby.png",
    "Sapphire": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Sapphire.png",
    "Turquoise": "https://s3-us-west-2.amazonaws.com/swatchify-static.sellerpanda.com/swatches/doyleanddoyle/Gemstone/Turquoise.png"
  }
};


// $('a.globomenu-target ').each(function() {
//   $(this).attr('href', $(this).attr('href').split('#')[0]);
// })



  /**********/
  /* SEARCH */
  /**********/
// $(window).on("load", function () {

//     if($('body').hasClass('template-search')){
//       if($('.error-msg:visible')){
//         $('.template-search .collection-main').addClass('hide');
//       }
//       else {
//         $('.template-search .collection-main').addClass('show');
//       }
//     }

// });
